"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFERROR = void 0;
const tab_1 = require("../../../tab");
exports.IFERROR = {
    description: "can be used to check if a given field has an error, and choose a value if it has, and another value if it doesn't",
    arg_names: ['field', 'return_if_error', 'return_if_not_error'],
    args_def: [
        {
            types: ['string', 'number', 'boolean', 'date'],
            required: true,
        },
        {
            types: ['string', 'number', 'boolean', 'date'],
            required: true,
        },
        {
            types: ['string', 'number', 'boolean', 'date'],
            required: false,
        },
    ],
    args_description: [
        'field that may have error',
        'return if it has error',
        "return if it doesn't have error",
    ],
    multipleReturnType: true,
    return_type: tab_1.ColumnType.STRING || tab_1.ColumnType.NUMBER || tab_1.ColumnType.BOOLEAN || tab_1.ColumnType.DATE,
};
